export default "__VITE_ASSET__CJsMu2w7__"